export default __webpack_public_path__ + "static/media/EuclidCircularA-Regular.849b372b.ttf";